var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_1152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z",
    fill: "url(#paint0_linear_72_1152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4922 16.6331L12.3311 21.723C12.3311 21.723 12.5611 22.1992 12.8072 22.1992C13.0534 22.1992 16.7152 18.3899 16.7152 18.3899L20.7872 10.5249L10.5578 15.3192L10.4922 16.6331Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9305 17.9384L12.5775 21.6902C12.5775 21.6902 12.4297 22.8398 13.579 21.6902C14.7284 20.5406 15.8285 19.6541 15.8285 19.6541",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5254 16.8147L6.74262 15.5821C6.74262 15.5821 6.29054 15.3987 6.43611 14.9828C6.46607 14.897 6.52652 14.8241 6.70736 14.6986C7.54552 14.1144 22.221 8.83965 22.221 8.83965C22.221 8.83965 22.6354 8.70002 22.8798 8.79289C22.9403 8.81161 22.9947 8.84604 23.0374 8.89268C23.0802 8.93932 23.1098 8.99648 23.1233 9.05833C23.1497 9.16756 23.1607 9.27994 23.1561 9.39222C23.1549 9.48936 23.1432 9.57939 23.1343 9.72057C23.0449 11.1627 20.3701 21.9259 20.3701 21.9259C20.3701 21.9259 20.2101 22.5557 19.6367 22.5773C19.4958 22.5819 19.3554 22.558 19.2239 22.5071C19.0924 22.4563 18.9725 22.3794 18.8714 22.2812C17.7462 21.3134 13.8572 18.6998 12.9979 18.1251C12.9785 18.1118 12.9622 18.0946 12.95 18.0746C12.9379 18.0545 12.9301 18.0321 12.9274 18.0088C12.9154 17.9482 12.9812 17.8732 12.9812 17.8732C12.9812 17.8732 19.7529 11.854 19.9331 11.2221C19.9471 11.1732 19.8944 11.149 19.8236 11.1705C19.3738 11.3359 11.5771 16.2596 10.7166 16.803C10.6546 16.8218 10.5892 16.8258 10.5254 16.8147Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_1152",
    x1: 15.5,
    y1: 31,
    x2: 15.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_1152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.652057e18d6dad3797ac10c7b9c54c6e.svg";
export { ForwardRef as ReactComponent };